<template>
  <div class="errors-view uk-container uk-container-small">
    <router-view />
    <pre v-if="isAuthenticatedAsAdmin && message">{{message}}</pre>
  </div>
</template>

<script>
import Authentication from '@/mixins/Authentication';

export default {
  name: 'errors-view',
  mixins: [Authentication],
  computed: {
    message() {
      return this.$route.query.message;
    },
  },
};
</script>



// WEBPACK FOOTER //
// ErrorsView.vue?a19e65ba